import { render, staticRenderFns } from "./SetTestView.vue?vue&type=template&id=4c8892fc&scoped=true&"
import script from "./SetTestView.vue?vue&type=script&lang=js&"
export * from "./SetTestView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8892fc",
  null
  
)

export default component.exports